import { Component, Input, ViewEncapsulation } from '@angular/core';
import { PopoverController } from '@ionic/angular';
import { Router } from '@angular/router';

@Component({
  selector: 'app-graphical-report-menu-popover',
  templateUrl: './graphical-report-menu-popover.component.html',
  styleUrls: ['./graphical-report-menu-popover.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class GraphicalReportMenuPopoverComponent {
  @Input() showFuel = false;
  @Input() showTemperature = false;

  constructor(
    private popoverCtrl: PopoverController,
    private router: Router,
  ) {}

  async choose(action: 'technical' | 'fuel' | 'temperature') {
    await this.popoverCtrl.dismiss({ action });
    if (action === 'temperature') {
      this.router.navigate(['/tempData']);
    }
  }
}
